import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const styles = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  borderRadius: "30px",
  p: 1.5,
  px: 4,
  textTransform: "none",
  fontWeight: "bold",
};

const BigRoundedButton = ({ text, to, variant = "outlined" }) => {
  return (
    <Button component={Link} to={to} variant={variant} sx={styles}>
      {text}
    </Button>
  );
};

export default BigRoundedButton;